<template>
  <banners>
    <div
      class="container-max m-auto"
      :class="{
        'min-h-[94vh] bg-steel-100': !isDesktop,
      }"
    >
      <div class="flex items-center justify-between bg-white px-3 py-8">
        <h1 class="text-lg md:text-4xl">My Capacity</h1>

        <ButtonComponent
          variant="primary"
          @click="toggleCapacityModal"
        >
          Post Capacity
        </ButtonComponent>
      </div>

      <div class="flex gap-3">
        <CapacityTable
          :is-desktop="isDesktop"
          :selectedTab="selectedTab"
          @handle-tab-selection="handleTabSelection"
        ></CapacityTable>
      </div>

      <post-capacity-modal
        v-if="isCapacityModalVisible"
        :visible="isCapacityModalVisible"
        @close="toggleCapacityModal"
        @error="handlePostTruckError"
        @handle-tab-selection="handleTabSelection"
      ></post-capacity-modal>

      <NotificationComponent
        v-show="showTruckNotication"
        title="Unable to Post Truck"
        @close="handleCloseTruckNotification"
      >
        <div
          v-if="errorMessage?.length > 0"
          class="text-left"
        >
          <p class="mb-2 text-sm font-normal text-steel-800">
            The following issues occured:dsd
          </p>
          <p
            v-for="(error, errorIndex) in errorMessage"
            :key="errorIndex"
            class="text-sm font-normal text-steel-700"
          >
            {{ error }}.
          </p>

          <span
            class="ml-auto mr-2 flex w-max cursor-pointer text-sm text-sun-700 underline"
            @click="handleRetry"
            >Retry</span
          >
        </div>
      </NotificationComponent>
    </div>
  </banners>
</template>

<script setup>
import { onBeforeMount, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { Banners, ButtonComponent, NotificationComponent } from '@/components';
import { CapacityTable, PostCapacityModal } from '@/components/loads';
import { useScreenSize } from '@/composables/useScreenSize';
import { capitalizeWords } from '@/utils/loadBoardUtils';
import { useRouter } from 'vue-router';

const router = useRouter();

const store = useStore();
const { screenSize } = useScreenSize();

const isDesktop = computed(() => screenSize.value === 'desktop');

onBeforeMount(async () => {
  await store.dispatch('loads/getTruckPostings', {
    query: '?q[is_active_eq]=1',
  });
  await store.dispatch('loads/getExpiredTruckPostings', {});
  await store.dispatch('loads/getEquipmentTypes');

  // might need different endpoint here
  await store.dispatch(
    'loads/getCarrierVehicles',
    store.state.users?.currentUser?.requested_carrier_id
  );
});

const selectedTab = ref('Active');

const handleTabSelection = (tab) => {
  selectedTab.value = tab;
};

const truckPostingError = computed(
  () => store.state.loads?.truck_posting_error
);

const errorMessage = computed(() => {
  return Object.entries(truckPostingError?.value)?.map(([key, value]) => {
    if (!Array.isArray(value)) {
      return '';
    }

    let title;

    if (key === 'origin_area_id') {
      title = 'Origin';
    } else if (key === 'destination_area_id') {
      title = 'Destination';
    } else if (key === 'carrier_vehicle') {
      title = 'Vehicle';
    } else {
      title = capitalizeWords(key?.replace(/_/g, ' '));
    }

    const values = value?.reduce((acc, el, index) => {
      if (index > 0) {
        acc += ` and ${el}`;
      } else {
        acc += el;
      }

      return acc;
    }, '');

    return `${title}: ${values}`;
  });
});

const isCapacityModalVisible = ref(
  router.currentRoute.value.query?.modal === 'post-capacity' ? true : false
);

const toggleCapacityModal = () => {
  isCapacityModalVisible.value = !isCapacityModalVisible.value;
};

const handlePostTruckError = () => {
  isCapacityModalVisible.value = false;
  showTruckNotication.value = true;
};

const showTruckNotication = ref(false);

const handleCloseTruckNotification = () => {
  showTruckNotication.value = false;
};

const handleRetry = () => {
  handleCloseTruckNotification();
  toggleCapacityModal();
};

// watch(
//   () => showTruckNotication.value,
//   (newValue) => {
//     if (newValue) {
//       setTimeout(() => {
//         showTruckNotication.value = false;
//       }, 5000);
//     }
//   }
// );
</script>
